var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":"36px"}},[_c('img',{class:[this.myEdit ? 'saved' : 'not-saved'],attrs:{"src":_vm.userImage,"alt":"Avatar"}})])}
var staticRenderFns = []

export { render, staticRenderFns }